import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() => import("views/auth-views/authentication/login"))
  },
  {
    key: "resetPassword",
    path: `${AUTH_PREFIX_PATH}/passwordReset`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/reset-password")
    )
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    )
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    )
  },
  {
    key: "sso-auth",
    path: `${AUTH_PREFIX_PATH}/sso`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/sso")
    )
  },
  {
    key: "influencer-acceptions",
    path: `${AUTH_PREFIX_PATH}/influencer`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/influencer-invitation")
    )
  },
  {
    key: "aggregator-acceptions",
    path: `${AUTH_PREFIX_PATH}/aggregator`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/influencer-invitation")
    )
  },
  {
    key: "instagram-acceptions",
    path: `${AUTH_PREFIX_PATH}/instagram`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/influencer-invitation")
    )
  }
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/dashboard")
    )
  },

  {
    key: "adminAnalytics",
    path: `${APP_PREFIX_PATH}/admin/analytics`,
    component: React.lazy(() =>
      import("views/app-views/admin-analytics")
    )
  },
  {
    key: "adminCoupons",
    path: `${APP_PREFIX_PATH}/admin/coupons`,
    component: React.lazy(() =>
      import("views/app-views/coupons")
    )
  },

  {
    key: "plans",
    path: `${APP_PREFIX_PATH}/shopify/plans`,
    component: React.lazy(() =>
      import("views/app-views/shopify-plans")
    )
  },

  {
    key: "verify",
    path: `/subscription/verify`,
    component: React.lazy(() =>
      import("views/app-views/shopify-plans/VerifyToken.js")
    )
  },
  {
    key: "sociaMediaPost",
    path: `${APP_PREFIX_PATH}/socialMediaPost`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/social-media-post")
    )
  },
  {
    key: "billingAppsumo",
    path: `${APP_PREFIX_PATH}/appsumo/billing`,
    component: React.lazy(() =>
      import("views/app-views/billing")
    )
  },

  {
    key: "shoppable-feeds.dashboard",
    path: `${APP_PREFIX_PATH}/shoppable-feeds/dashboard`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/dashboard")
    )
  },

  {
    key: "shoppable-feeds.create",
    path: `${APP_PREFIX_PATH}/shoppable-feeds/create`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/create-feed")
    )
  },
  {
    key: "shoppable-feeds.createForm",
    path: `${APP_PREFIX_PATH}/shoppable-feeds/createFeedForm`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/create-feed-form")
    )
  },

  {
    key: "shoppable-feeds.list",
    path: `${APP_PREFIX_PATH}/shoppable-feeds/list`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/feed-list")
    )
  },

  {
    key: "shoppable-feeds.creation",
    path: `${APP_PREFIX_PATH}/shoppable-feeds/creation`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/creation")
    ),
  },
  {
    key: "shoppable-feeds.creation",
    path: `${APP_PREFIX_PATH}/shoppable-feeds/creation/reels`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/Reels-Video")
    ),
  },
  {
    key: "shoppable-feeds.creation",
    path: `${APP_PREFIX_PATH}/shoppable-feeds/creation/reelsNav`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/Reels-Video")
    ),
  },
  {
    key: "shoppable-feeds.creation",
    path: `${APP_PREFIX_PATH}/shoppable-feeds/creation/reels/add`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/create-feed/MultipleFeedCreationPage")
    ),
  },
  {
    key: "shoppable-feeds.creation",
    path: `${APP_PREFIX_PATH}/shoppable-feeds/creation/story`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/shoppable-feed-story/index")
    ),
  },
  {
    key: "shoppable-feeds.creation",
    path: `${APP_PREFIX_PATH}/shoppable-feeds/creation/storyNav`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/shoppable-feed-story/index")
    ),
  },
  {
    key: "video.add",
    path: `${APP_PREFIX_PATH}/video/add`,
    component: React.lazy(() => import("views/app-views/video/add-video"))
  },

  {
    key: "video.list",
    path: `${APP_PREFIX_PATH}/video/list`,
    component: React.lazy(() => import("views/app-views/video/video-list"))
  },

  //quizz routes
  {
    key: "shoppableQuiz.list",
    path: `${APP_PREFIX_PATH}/sfQuiz/list`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/quizz")
    )
  },
  //poll routes
  {
    key: "shoppablePoll.list",
    path: `${APP_PREFIX_PATH}/sfPoll/list`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/polls")
    )
  },
  {
    key: "shoppableForm.list",
    path: `${APP_PREFIX_PATH}/sfForm/list`,
    component: React.lazy(() =>
      import("views/app-views/shoppable_feed_form/formList")
    )
  },
  {
    key: "shoppableForm.create",
    path: `${APP_PREFIX_PATH}/sfForm/list/createForm`,
    component: React.lazy(() =>
      import("views/app-views/shoppable_feed_form/formList/form")
    )
  },

  {
    key: "product.add",
    path: `${APP_PREFIX_PATH}/product/add`,
    component: React.lazy(() => import("views/app-views/products/product-add"))
  },
  {
    key: "product.list",
    path: `${APP_PREFIX_PATH}/product/list`,
    component: React.lazy(() => import("views/app-views/products/product-list"))
  },

  {
    key: "category.list",
    path: `${APP_PREFIX_PATH}/plp-category/list`,
    component: React.lazy(() => import("views/app-views/plp_category"))
  },

  {
    key: "live-call.analytics",
    path: `${APP_PREFIX_PATH}/live-call/analytics`,
    component: React.lazy(() =>
      import("views/app-views/one-to-one/analytics-report")
    )
  },
  {
    key: "live-call.history",
    path: `${APP_PREFIX_PATH}/live-call/history`,
    component: React.lazy(() =>
      import("views/app-views/one-to-one/call-history")
    )
  },
  {
    key: "live-call.scheduled",
    path: `${APP_PREFIX_PATH}/live-call/scheduled`,
    component: React.lazy(() =>
      import("views/app-views/live-call/call-scheduled")
    )
  },
  {
    key: "live-call.faq",
    path: `${APP_PREFIX_PATH}/live-call/faq`,
    component: React.lazy(() =>
      import("views/app-views/one-to-one/faqs-and-queries")
    )
  },
  //LIVE STREAM PATHS

  {
    key: "live-stream.customisation",
    path: `${APP_PREFIX_PATH}/live-call/customisation`,
    component: React.lazy(() =>
      import("views/app-views/one-to-many/Customisation")
    )
  },
  {
    key: "live-stream.stream",
    path: `${APP_PREFIX_PATH}/live-call/stream`,
    component: React.lazy(() =>
      import("views/app-views/one-to-many/LiveStreamView")
    )
  },
  {
    key: "live-stream.stream",
    path: `${APP_PREFIX_PATH}/live-call/stream/schedule`,
    component: React.lazy(() =>
      import("views/app-views/one-to-many/LiveStreamSchedule/NewDesign")
    )
  },

  {
    key: "live-stream.stream.create",
    path: `${APP_PREFIX_PATH}/live-call/stream/schedule/createStream`,
    component: React.lazy(() =>
      import("views/app-views/one-to-many/LiveStreamSchedule/LivestreamComponent/NewCreateStream")
    )
  },

  // {
  //     key: "account.on-boarding",
  //     path: `${APP_PREFIX_PATH}/account/on-boarding`,
  //     component:React.lazy(()=>import("views/app-views/account/onboarding"))
  // },

  // {
  //     key: "shoppable-feeds",
  //     path: `${APP_PREFIX_PATH}/shoppable-feeds`,
  //     component: React.lazy(() => import("views/app-views/dashboards/default")),
  // },
  // {
  //     key: "shoppable-feeds.feeds",
  //     path: `${APP_PREFIX_PATH}/shoppable-feeds/feeds`,
  //     component: React.lazy(() => import("views/app-views/dashboards/default")),
  // },
  // {
  //     key: "shoppable-feeds.add-feed",
  //     path: `${APP_PREFIX_PATH}/shoppable-feeds/add-feed`,
  //     component: React.lazy(() => import("views/app-views/feeds")),
  // },
  // {
  //     key: "products.add-product",
  //     path: `${APP_PREFIX_PATH}/products/add-product`,
  //     component: React.lazy(() => import("views/app-views/products")),
  // },
  //
  {
    key: "live-call.live-call",
    path: `${APP_PREFIX_PATH}/live-call/live-call`,
    component: React.lazy(() => import("views/app-views/live-call/livecall"))
  },

  {
    key: "account-setting",
    path: `${APP_PREFIX_PATH}/account-settings`,
    component: React.lazy(() => import("views/app-views/account-settings"))
  },
  {
    key: "one-to-one",
    path: `${APP_PREFIX_PATH}/one-to-one`,
    component: React.lazy(() =>
      import("views/app-views/one-to-one/one-to-one-view")
    )
  },

  {
    key: "library",
    path: `${APP_PREFIX_PATH}/library`,
    component: React.lazy(() => import("views/app-views/library"))
  },

  {
    key: "widgets",
    path: `${APP_PREFIX_PATH}/widgets`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/shoppable-feed-widget"))
  },

  {
    key: "widgets",
    path: `${APP_PREFIX_PATH}/widgetsNav`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/shoppable-feed-widget"))
  },

  {
    key: "widgets",
    path: `${APP_PREFIX_PATH}/widgets/sfRank`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/shoppable-feed-widget/Ranking"))
  },

  {
    key: "widgets.customisation.sf",
    path: `${APP_PREFIX_PATH}/customisation/sf`,
    component: React.lazy(() =>
      import("views/app-views/custamisation/shoppable-feeds")
    )
  },
  {
    key: "widgets.customisation.sf",
    path: `${APP_PREFIX_PATH}/customisation/sf-pdp`,
    component: React.lazy(() =>
      import(
        "views/app-views/custamisation/shoppable-feeds/shoppable-feeds-pdp"
      )
    )
  },
  {
    key: "widgets.customisation.sf",
    path: `${APP_PREFIX_PATH}/customisation/sf-pip`,
    component: React.lazy(() =>
      import("views/app-views/custamisation/shoppable-feeds/shoppable-feed-pip")
    )
  },
  {
    key: "widgets.customisation.sf",
    path: `${APP_PREFIX_PATH}/customisation/pipHomepage`,
    component: React.lazy(() =>
      import("views/app-views/widgets/Homepage_pip")
    )
  },
  {
    key: "widgets.customisation.sf",
    path: `${APP_PREFIX_PATH}/customisation/story`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/shoppable-feed-widget/storyWidget")
    )
  },
  {
    key: "widgets.customisation.sf",
    path: `${APP_PREFIX_PATH}/all-widgets/story/:id`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/shoppable-feed-widget/storyWidget")
    )
  },
  {
    key: "widgets.customisation.banner",
    path: `${APP_PREFIX_PATH}/all-widgets/banner`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/shoppable-feed-widget/Banner")
    )
  },
  {
    key: "widgets.customisation.interactive",
    path: `${APP_PREFIX_PATH}/all-widgets/interactive-pip`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/shoppable-feed-widget/Interactive-Pip")
    )
  },
  {
    key: "widgets.customisation.collectionCustomisation",
    path: `${APP_PREFIX_PATH}/all-widgets/collection/customisation/vcBlock`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/shoppable-feed-widget/Collection/index")
    )
  },
  {
    key: "widgets.customisation.collectionCustomisation",
    path: `${APP_PREFIX_PATH}/all-widgets/collection/customisation/story`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/shoppable-feed-widget/Collection/StoryCustomisation")
    )
  },
  {
    key: "widgets.customisation.sf",
    path: `${APP_PREFIX_PATH}/customisation/automatedStory`,
    component: React.lazy(() =>
      import("views/app-views/custamisation/story/AutomatedStory")
    )
  },
  {
    key: "widgets.customisation.sf",
    path: `${APP_PREFIX_PATH}/customisation/story-pdp`,
    component: React.lazy(() =>
      import("views/app-views/custamisation/story/storyOnPdp")
    )
  },

  {
    key: "widgets.generate.script",
    path: `${APP_PREFIX_PATH}/widgets/generate-script`,
    component: React.lazy(() =>
      import("views/app-views/widgets/generate-script")
    )
  },

  {
    key: "shoppable-feeds.analytics",
    path: `${APP_PREFIX_PATH}/shoppable-feed/analytics`,
    component: React.lazy(() =>
      import(
        "views/app-views/shoppable-feeds/analytics-report-v2/analytics_new"
      )
    )
  },

  {
    key: "shoppable-feeds.analytics",
    path: `${APP_PREFIX_PATH}/shoppable-feed/analyticsSF`,
    component: React.lazy(() =>
      import(
        "views/app-views/shoppable-feeds/analytics-report-v2/analytics_new"
      )
    )
  },

  {
    key: "shoppable-feeds.analytics.configure",
    path: `${APP_PREFIX_PATH}/shoppable-feed/analytics/configureSteps`,
    component: React.lazy(() =>
      import(
        "views/app-views/shoppable-feeds/analytics-report-v2/analytics_new/ConfigureSteps"
      )
    )
  },

  {
    key: "shoppable-feeds.productViewMore",
    path: `${APP_PREFIX_PATH}/shoppable-feed/analytics/productViewMore`,
    component: React.lazy(() =>
      import(
        "views/app-views/shoppable-feeds/analytics-report-v2/analytics_new/View-More/TopProduct"
      )
    )
  },

  {
    key: "shoppable-feeds.widgetsViewMore",
    path: `${APP_PREFIX_PATH}/shoppable-feed/analytics/widgetViewMore`,
    component: React.lazy(() =>
      import(
        "views/app-views/shoppable-feeds/analytics-report-v2/analytics_new/View-More/TopWidget"
      )
    )
  },

  {
    key: "shoppable-feeds.feedsViewMore",
    path: `${APP_PREFIX_PATH}/shoppable-feed/analytics/feedViewMore`,
    component: React.lazy(() =>
      import(
        "views/app-views/shoppable-feeds/analytics-report-v2/analytics_new/View-More/TopFeeds"
      )
    )
  },

  {
    key: "shoppable-feeds.customization",
    path: `${APP_PREFIX_PATH}/shoppable-feed/customization`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/shoppable-feed-customization-v2")
    )
  },
  {
    key: "shoppable-feeds.customizationNew",
    path: `${APP_PREFIX_PATH}/shoppable-feed/customizationNew`,
    component: React.lazy(() =>
      import("views/app-views/custamisation/customizationNew/common")
    )
  },

  {
    key: "shoppable-feeds.customizationNew.actionable",
    path: `${APP_PREFIX_PATH}/shoppable-feed/customizationNew/layout/:id`,
    component: React.lazy(() =>
      import("views/app-views/custamisation/customizationNew/common/layout")
    )
  },

  // ${APP_PREFIX_PATH}/stories/customization
  {
    key: "stories.customization",
    path: `${APP_PREFIX_PATH}/stories/customization`,
    component: React.lazy(() =>
      import("views/app-views/stories/stories-customization")
    )
  },

  {
    key: "all-widgets",
    path: `${APP_PREFIX_PATH}/all-widgets`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/shoppable-feed-widget/available-widget"))
  },
  {
    key: "all-widgets",
    path: `${APP_PREFIX_PATH}/all-widgets/vcBlockVideo/:id`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/shoppable-feed-widget/VC-Block"))
  },
  {
    key: "all-widgets",
    path: `${APP_PREFIX_PATH}/all-widgets/vcBlockNonVideo/:id`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/shoppable-feed-widget/VC-Block/nonVideoPlayer"))
  },

  {
    key: "all-widgets",
    path: `${APP_PREFIX_PATH}/all-widgets/vcSpotlight/:id`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/shoppable-feed-widget/VC-Spotlight"))
  },
  {
    key: "all-widgets",
    path: `${APP_PREFIX_PATH}/all-widgets/sfPIPpdp`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/shoppable-feed-widget/sfPIP/pipForPDP"))
  },
  {
    key: "all-widgets",
    path: `${APP_PREFIX_PATH}/all-widgets/sfPIPhome`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/shoppable-feed-widget/sfPIP/pipForHome"))
  },
  {
    key: "all-widgets",
    path: `${APP_PREFIX_PATH}/all-widgets/interactiveSfPip`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/shoppable-feed-widget/FPQWidget"))
  },
  {
    key: "all-widgets",
    path: `${APP_PREFIX_PATH}/all-widgets/plpCategory`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/shoppable-feed-widget/PLPCategory"))
  },
  {
    key: "all-widgets",
    path: `${APP_PREFIX_PATH}/all-widgets/atc`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/shoppable-feed-widget/ATC-Widget"))
  },
  {
    key: "widgets-viewmore",
    path: `${APP_PREFIX_PATH}/widgets-viewmore/:id`,
    component: React.lazy(() => import("views/app-views/widgets/view-more"))
  },
  {
    key: "widgets-viewmore",
    path: `${APP_PREFIX_PATH}/widgets-viewmore-story/:id`,
    component: React.lazy(() =>
      import("views/app-views/widgets/view-more/UpdateStory")
    )
  },
  {
    key: "stories",
    path: `${APP_PREFIX_PATH}/stories`,
    component: React.lazy(() =>
      import("views/app-views/shoppable-feeds/shoppable-feed-story")
    )
  },
  {
    key: "top-widgets-list",
    path: `${APP_PREFIX_PATH}/top-widgets-list`,
    component: React.lazy(() =>
      import(
        "views/app-views/shoppable-feeds/top-items-view-more/top-widgets-list"
      )
    )
  },
  {
    key: "top-feeds-list",
    path: `${APP_PREFIX_PATH}/top-feeds-list`,
    component: React.lazy(() =>
      import(
        "views/app-views/shoppable-feeds/top-items-view-more/top-feeds-list"
      )
    )
  },
  {
    key: "top-products-list",
    path: `${APP_PREFIX_PATH}/top-products-list`,
    component: React.lazy(() =>
      import(
        "views/app-views/shoppable-feeds/top-items-view-more/top-products-list"
      )
    )
  },
  {
    key: "top-category-list",
    path: `${APP_PREFIX_PATH}/top-category-list`,
    component: React.lazy(() =>
      import(
        "views/app-views/shoppable-feeds/top-items-view-more/top-category-list"
      )
    )
  },

  {
    key: "one-to-one-customization",
    path: `${APP_PREFIX_PATH}/one-to-one/customization`,
    component: React.lazy(() =>
      import(
        "views/app-views/one-to-one/plugin-customization/customization-form"
      )
    )
  },
  {
    key: "video-tutorials",
    path: `${APP_PREFIX_PATH}/video-tutorials`,
    component: React.lazy(() =>
      import(
        "views/app-views/video-tutorials"
      )
    )
  },
  // custom link routes
  {
    key: "custom_link",
    path: `${APP_PREFIX_PATH}/customLink`,
    component: React.lazy(() => import("views/app-views/shoppable-feeds/CustomLink"))
  },
];
